import axios from "axios";

const http = axios.create({
  baseURL: process.env.React_App_AWS_API,
  headers: {
    "Content-type": "application/json",
  },
});

http.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response && error.response.status === 401 && original && !original._retry) {
      original._retry = true;
      const sent = original.headers && original.headers.Authorization;
      await new Promise((resolve) => setTimeout(resolve, 800));
      const token = sessionStorage.getItem("accToken") || localStorage.getItem("accToken");
      if (token && "Bearer " + token !== sent) {
        original.headers.Authorization = "Bearer " + token;
        return http(original);
      }
    }
    return Promise.reject(error);
  }
);

export default http;